import { IconProps } from './types';
import Theme from '../../components-library/Theme';
import classnames from 'classnames';

export default function HomeIcon({ color, className }: IconProps) {
  return (
    <svg
      className={classnames('h-4 w-4', className)}
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_25738_15096)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5634 0.737601C11.9189 0.416931 12.4606 0.421355 12.8109 0.747789L23.7062 10.9016C24.0792 11.2492 24.0998 11.8333 23.7522 12.2063C23.4046 12.5792 22.8205 12.5998 22.4476 12.2522L12.1714 2.67534L1.5413 12.2624C1.16272 12.6038 0.579041 12.5737 0.237608 12.1951C-0.103824 11.8166 -0.0737116 11.2329 0.304866 10.8914L11.5634 0.737601Z"
          fill={color ?? Theme.color.gray['100']}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.69261 1.42285C4.20241 1.42285 4.61568 1.83613 4.61568 2.34593V22.6536L8.57172 22.6536V16.4147C8.57172 15.3951 9.39828 14.5686 10.4179 14.5686H13.8464C14.866 14.5686 15.6926 15.3951 15.6926 16.4147V22.6536H19.3849V9.1884C19.3849 8.6786 19.7982 8.26533 20.308 8.26533C20.8178 8.26533 21.2311 8.6786 21.2311 9.1884V22.6536C21.2311 23.6732 20.4045 24.4998 19.3849 24.4998H15.6926C14.673 24.4998 13.8464 23.6732 13.8464 22.6536V16.4147H10.4179V22.6536C10.4179 23.6732 9.59133 24.4998 8.57172 24.4998H4.61568C3.59608 24.4998 2.76953 23.6732 2.76953 22.6536V2.34593C2.76953 1.83613 3.18281 1.42285 3.69261 1.42285Z"
          fill={color ?? Theme.color.gray['100']}
        />
      </g>
      <defs>
        <clipPath id="clip0_25738_15096">
          <rect width="24" height="24" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}
